import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { resolver } from "../../API/middlewares/resolveRequests";
import { useSelector } from "react-redux";
import CoverBar from "./coverBar";
import { getUserProfileDetails } from "./../../API/store/actions/auth";
import AboutUser from "./aboutUser";

const UserProfileIndex = ({ tabId }) => {
  const [userProfileData, setUserProfileData] = useState({});
  const userToken = useSelector((state) => state.login.userToken);
  const userLogged = useSelector((state) => state.login.userData);
  const [id, setId] = useState(tabId ?? "A5");

  const { roomId } = useParams();

  useEffect(() => {
    resolver(
      getUserProfileDetails,
      setUserProfileData,
      userLogged?.id,
      userToken
    );
  }, [userLogged, id]);

  const [tabID, setTabID] = useState(tabId);

  useEffect(() => {
    let NavElements = document.querySelectorAll(".itemNav");
    for (let i = 0; i < NavElements?.length; i++) {
      if (
        NavElements[i]?.children[0]?.classList?.contains("iconsActiveClass")
      ) {
        NavElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        NavElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      }
    }
  }, []);

  return (
    <>
      <CoverBar details={userProfileData?.data} />
      <AboutUser
        details={userProfileData?.data}
        id={id}
        setId={setId}
        tabId={tabID}
        setTabID={setTabID}
        roomId={roomId}
      />
    </>
  );
};

export default UserProfileIndex;
